import { DTOModel } from "../../../models/base/dto-model";
import { PublishSplitEmployeeDocumentFilesSTO } from "../../../models/split-document/split-employee-document/publish-split-employee-document-files-sto";
import { BaseApiService } from "../../../services/base";

export class PublishSplitEmployeeDocumentApiService extends BaseApiService<
  DTOModel,
  PublishSplitEmployeeDocumentFilesSTO
> {
  constructor() {
    super({
      servicePath: "/SplitEmployeeDocument",
      loadItemsPath: "/",
      saveItemsPath: "/PublishSplitEmployeeDocumentFiles",
    });
  }
}
